import type { NodeSn } from '../../../nodes/index';
import {
  type KeyOfType,
  getValueFromKeyOfType,
} from '../../../types/KeyOfType';
import { createDefaultFilter } from '../../filters/createDefaultFilter';
import { createTextFilter } from '../../filters/types/textFilter';
import type { TableColumnBase } from '../TableColumnBase';
import {
  type TableDataColumnConfig,
  pickTableColumnConfig,
} from '../TableColumnConfig';

export type TableColumnFormatInterface<TRow> = {
  type: 'interface';
  field: KeyOfType<TRow, string | null>;
  snField: KeyOfType<TRow, NodeSn>;
};

export const createInterfaceColumn = <TRow>(
  config: TableDataColumnConfig<TRow, string | null> & {
    snField: KeyOfType<TRow, NodeSn>;
    array?: false;
  },
): TableColumnBase<TRow, TableColumnFormatInterface<TRow>> => ({
  ...pickTableColumnConfig(config),
  format: {
    type: 'interface',
    field: config.key,
    snField: config.snField,
  },
  csvStringDependencies: [config.key],
  webDependencies: [config.key, config.snField],
  toCsvString: (row) =>
    getValueFromKeyOfType<TRow, string | null>(row, config.key) ?? '',
  filter: createDefaultFilter(config.filter, createTextFilter()),
});
